export function stepIsVisible(step, answers) {
  if (!step?.showIf) return true;
  const value = answers[step.showIf.field];
  // Multi-select answers (e.g. `goals`) are arrays — mirrored in server.js.
  if (Array.isArray(value)) return value.includes(step.showIf.equals);
  return value === step.showIf.equals;
}
